function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { defineComponent } from "vue";
import IconPureLanguage from "./icon-pure-language.vue";
import { IconResolverProp } from "./props";
export default defineComponent({
    components: {
        IconPureLanguage: IconPureLanguage
    },
    props: _objectSpread({
        code: String,
        name: {
            type: String,
            required: true
        },
        // 是否显示code
        showCode: {
            type: Boolean,
            default: false
        }
    }, IconResolverProp)
});
